// extracted by mini-css-extract-plugin
export default {"content":"my-account-wrapper-component_content__KHHyf"};